export const useSeparateLastWordFromPhrase = (phrase: string) => {
	const n = phrase.lastIndexOf(' ');
	const phraseWithoutLastWord = phrase.substring(0, n);
	const lastWord = phrase.substring(n + 1);
	return { phraseWithoutLastWord, lastWord };
};
